import { useState } from "react";

function PublicPresentationContactCard({
  contact,
  onPhoneActivate,
  onEmailActivate,
}) {
  const name = contact && contact.name ? String(contact.name).trim() : "";
  const phone = contact && contact.phone ? String(contact.phone).trim() : "";
  const email = contact && contact.email ? String(contact.email).trim() : "";
  const avatarUrl = contact && contact.avatar_url ? String(contact.avatar_url).trim() : "";
  const [avatarFailed, setAvatarFailed] = useState(false);

  if (!name && !phone && !email && !avatarUrl) return null;

  const hasChannel = Boolean(phone || email);
  const showAvatar = Boolean(avatarUrl) && !avatarFailed;

  const actions = hasChannel ? (
    <div className="presentation-contact__actions">
      {phone ? (
        <a
          className="action-btn action-btn--primary presentation-contact__cta-primary"
          href={`tel:${phone}`}
          onClick={() => onPhoneActivate?.()}
          data-testid="presentation-contact-phone"
        >
          <i className="fa-solid fa-phone" aria-hidden="true" />
          Зателефонувати
        </a>
      ) : null}
      {email ? (
        <a
          className="action-btn presentation-contact__cta-secondary"
          href={`mailto:${email}`}
          onClick={() => onEmailActivate?.()}
          data-testid="presentation-contact-email"
        >
          <i className="fa-solid fa-envelope" aria-hidden="true" />
          Написати
        </a>
      ) : null}
    </div>
  ) : (
    <p className="presentation-contact__identity">Контакт без каналу зв'язку</p>
  );

  return (
    <>
      <aside className="presentation-contact" aria-label="Контакти">
        <div className="presentation-contact__card">
          {showAvatar ? (
            <img
              className="presentation-contact__avatar"
              src={avatarUrl}
              alt=""
              onError={() => setAvatarFailed(true)}
              data-testid="presentation-contact-avatar"
            />
          ) : null}
          <div className="presentation-contact__body">
            {name ? <p className="presentation-contact__name">{name}</p> : null}
            {actions}
          </div>
        </div>
      </aside>
    </>
  );
}

export default PublicPresentationContactCard;
